import { gql } from "@apollo/client";
import { episodeMetaFields, liveMetaFields, tvShowMetaFields, pageInfoFields } from "./fragments";
export const RTOASTER_TRACK_MUTATION = gql`
  mutation RtTrack($location: String!, $referrer: String, $sid: String) {
    track(location: $location, referrer: $referrer, sid: $sid) {
      result
    }
  }
`;
export const RTOASTER_RECOMMEND_QUERY = gql`
  ${episodeMetaFields}
  ${liveMetaFields}
  ${tvShowMetaFields}
  ${pageInfoFields}
  query RtRecommend($location: String!, $elementIds: [String!]) {
    recommend(location: $location, elementIds: $elementIds) {
      elementId
      data {
        ... on EpisodeMeta {
          ...episodeMetaFields
          rtsid
        }
        ... on LiveMeta {
          ...liveMetaFields
          rtsid
        }
        ... on TVShowMeta {
          ...tvShowMetaFields
          rtsid
        }
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;